import {
  itemModel,
  initialState,
  colors,
} from "@/views/user/exercises/challenges-system/model";

import { checkPopulated } from "@/utils/types";

export default {
  data() {
    return {
      proxyItems: this.items,
      activeItem: { ...initialState },
      colors: colors,
      editKey: 0,
      dialogMode: "",
      dialog: false,
    };
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    attrs: {
      type: Object,
      default: () => {},
    },
    local: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    items: {
      immediate: true,
      deep: true,
      handler() {
        this.proxyItems = [...this.items];
        console.log("proxy items", this.proxyItems);
      },
    },
  },
  methods: {
    addItem() {
      this.destroyProto();
      Object.assign(this.activeItem, initialState());
      this.editKey++;
      this.$nextTick(() => {
        this.dialogMode = "add";
        this.dialog = true;
      });
    },
    editItem(ev) {
      Object.assign(this.activeItem, ev);
      this.editKey++;
      this.$nextTick(() => {
        this.dialogMode = "edit";
        this.dialog = true;
      });
    },
    deleteItem(ev) {
      Object.assign(this.activeItem, ev);
      this.editKey++;
      this.$nextTick(() => {
        this.dialogMode = "delete";
        this.dialog = true;
      });
    },
    commitEdit(ev) {
      const validItem = this.constructItem({ ...itemModel }, ev);
      const item = this.proxyItems.find((x) => x.id === ev.id);
      const index = this.proxyItems.indexOf(item);
      this.$set(this.proxyItems, index, validItem);
      this.updateList();
      this.closeDialog();
    },
    commitSave(ev) {
      const item = this.constructItem({ ...itemModel }, ev);
      item.id = new Date().valueOf();
      this.proxyItems.push(item);
      this.updateList();
      this.closeDialog();
    },
    commitDelete() {
      const item = this.proxyItems.find((x) => x.id === this.activeItem.id);
      const index = this.proxyItems.indexOf(item);
      this.proxyItems.splice(index, 1);
      this.updateList();
      this.closeDialog();
    },
    constructItem(model, item) {
      const obj = {};
      Object.keys(model).forEach((key) => {
        console.log(key, item[key]);
        obj[key] = checkPopulated(item[key]);
      });
      return obj;
    },
    destroyProto() {
      Object.assign(this.activeItem, initialState());
      this.activeItem.id = new Date().valueOf();
    },
    closeDialog() {
      this.dialog = false;
      this.dialogMode = "";
      this.destroyProto();
    },
    updateList() {
      this.$emit("updated", this.proxyItems);
    },
    copyItem(ev) {
      var copyText = `${ev.name}\n${ev.challenge}`;
      navigator.clipboard.writeText(copyText);
    },
  },
};
